import Modal from '../../modules/Modal';
import store from '../../store';

export default function(context) {
	$(context).on('click', '[data-load]', function(event) {
		event.preventDefault();

		const url = this.getAttribute('data-load');
		const title = this.getAttribute('data-title') || this.innerText;
		const method = this.getAttribute('data-load-method') || 'GET';

		const styles = {};

		const modal = Modal.load(url, {
			title, 
			method
		});

		modal.subscribe(Modal.Events.HIDDEN, () => {
			modal.dispose();
		}); 

	});
}